import { faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { graphql, Link, type HeadFC, type PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';
import logo from '../images/elch_logo.svg';
import marketing_icon from '../images/usps/marketing.svg';
import DefaultLayout from '../layouts/default/default';

const IndexPage: React.FC<PageProps> = () => {
  return (
    <DefaultLayout
      banner={
        <>
          <StaticImage
            src="../images/header_images/hirschi.jpg"
            alt=""
            loading="lazy"
            placeholder="blurred"
          />
          <div className="inner">
            <div className="logo">
              <img
                width={350}
                height={350}
                src={logo}
                loading="lazy"
                decoding="async"
                alt="ELCh Digital Logo"
              />
            </div>
            <h2>Time to go digital...</h2>
            <p>
              Bereit für die Digitalisierung?
              <br />
              Wir freuen uns darauf, Sie zu begleiten!
            </p>
          </div>
        </>
      }>
      <section id="one" className={`wrapper spotlight style1`}>
        <div className="inner">
          <Link to="/ueberuns" className="image">
            <StaticImage
              src={'../images/usps/app.svg'}
              alt={'Illustration of a developer coding on a laptop with a code symbol'}
            />
          </Link>

          <div className="content">
            <h2 className="major">App...</h2>
            <p className="content-inner">
              Als Team aus Softwareentwicklern und -entwicklerinnen liegt unsere Kernkompetenz in
              der App-Entwicklung. Wir fokussieren uns auf moderne Technologien und entwickeln mit
              Ihnen zusammen die passende Lösung für Ihr Unternehmen.
            </p>
          </div>
        </div>
      </section>
      <section id="two" className={`wrapper spotlight style2 alt`}>
        <div className="inner">
          <Link to="/ueberuns" className="image">
            <StaticImage
              src={'../images/usps/web.svg'}
              alt={'Illustration of a person designing a web layout with a checkmark icon'}
            />
          </Link>
          <div className="content">
            <h2 className="major">...Web...</h2>
            <p className="content-inner">
              Ebenso passioniert bauen wir gemeinsam mit Ihnen Ihre Webpräsenz – basierend auf
              neuester Technik – genau nach Ihren Wünschen und beraten Sie rund um Design,
              Technologie und SEO.
            </p>
          </div>
        </div>
      </section>
      <section id="three" className={`wrapper spotlight style3`}>
        <div className="inner">
          <Link to="/ueberuns" className="image">
            <img src={marketing_icon} alt="" />
          </Link>
          <div className="content">
            <h2 className="major">...und alles drumherum!</h2>
            <p className="content-inner">
              Sie möchten noch mehr Sichtbarkeit für Ihr Unternehmen? Kein Problem. Wir erstellen
              Ihren Image-Film, Social-Media-Kampagne oder UI/UX-Rebranding und helfen Ihnen dabei,
              Ihre Zielgruppe zu erreichen!
            </p>
          </div>
        </div>
      </section>
      <section id="four" className="wrapper alt style1">
        <div className="inner">
          <h2 className="major">Projekte</h2>
          <section className="features">
            <article>
              <Link to="/projekte/sovd" className="image">
                <StaticImage
                  src={'../images/portfolio/Hand1_Main_menu.jpg'}
                  alt={''}
                  style={{ width: '100%' }}
                />
              </Link>
            </article>
            <article>
              <Link to="/projekte/sovd">
                <h3 className="major">„Mein SoVD“ – App für Android und iOS</h3>
                <p>
                  Als Allzeit bereiter Helfer verbindet die „Mein SoVD“-App Interessierte, Berater
                  und Mitglieder des SoVD-Landesverband Niedersachsen e.V. <br />
                  <br />
                  Nutzer und Nutzerinnern haben hier die Möglichkeit, Beratungstermine zu buchen und
                  zu verwalten, mit Beratern über die App zu kommunzieren, Dokumente zu übermitteln
                  oder Verfahren zu eröffnen. <br />
                  <br />
                  Ehrenamtliche Mitglieder können Sitzungen planen, Mitgliederlisten einsehen und
                  verwalten sowie Auswertungen abrufen.
                </p>
                <span style={{ marginRight: '15px' }}>Mehr dazu</span>
                <FontAwesomeIcon icon={faChevronCircleRight} />
              </Link>
            </article>
          </section>
        </div>
      </section>
    </DefaultLayout>
  );
};

export default IndexPage;

export const Head: HeadFC = () => (
  <>
    <html lang="de" />
    <title>ELCh Digital - Ihre Agentur für Web- & App-Entwicklung </title>
    <meta
      name="description"
      content=" Als Team aus Softwareentwicklern und -entwicklerinnen liegt unsere Kernkompetenz in
              der App-Entwicklung. Wir fokussieren uns auf moderne Technologien und entwickeln mit
              Ihnen zusammen die passende Lösung für Ihr Unternehmen."
    />
    <meta property="og:title" content="ELCh Digital - Ihre Agentur für Web- & App-Entwicklung" />
    <meta property="og:url" content="https://elch.digital" />
    <meta
      property="og:description"
      content="Wir bauen Apps, die begeistern. ELCh Digital entwickelt moderne digitale Lösungen für Startups und Unternehmen."
    />

    <meta property="og:image" content="/static/elch_logo-64ac8ba136667b6395de24300a0f59bf.svg" />

    <meta name="keywords" content="ELCh Digital, Softwareentwicklung, Webentwicklung" />
    <meta name="author" content="ELCh Digital" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet" />
    <link
      rel="preload"
      as="image"
      href="/static/elch_logo-64ac8ba136667b6395de24300a0f59bf.svg" // check the actual static path after build
      imageSrcSet="/static/path-to-hirschi.webp 1x, /static/path-to-hirschi.avif 2x"
      imageSizes="100vw"
    />
  </>
);

export const query = graphql`
  query {
    stag: file(relativePath: { eq: "header_images/hirschi.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
  }
`;
